<template>
  <div>
    <base-header class="pb-6" type="gray">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">Home</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <b-button to="/companies/create" size="sm" variant="neutral">
            New Company
            <i class="fa fa-plus ml-2"></i>
          </b-button>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-row class="starter-page">
        <loading
          :active.sync="loading"
          :can-cancel="false"
          :is-full-page="true"
        ></loading>

        <b-col
          v-if="!companies.length && !loading"
          class="text-center"
          cols="12"
          sm="8"
          offset-sm="2"
          md="6"
          offset-md="3"
          xl="4"
          offset-xl="4"
        >
          <card
            gradient="default"
            header-classes="bg-transparent"
            footer-classes="bg-transparent"
            body-classes="px-lg-7"
            class="card-pricing border-0 text-center"
          >
            <h2
              class="mt-2 h1 text-center text-white text-uppercase"
              slot="header"
            >
              Welcome
            </h2>

            <!-- <img src="/img/theme/man-at-window-illustration.svg" class="img-fluid px-8" /> -->
            <p class="text-lg text-white">
              Ready to set up your first company?
            </p>
            <p class="text-gray">It will only take a couple of minutes.</p>

            <b-btn slot="footer" block to="/companies/create" variant="primary">
              Get started
              <i class="fa fa-arrow-right ml-2"></i>
            </b-btn>
          </card>
        </b-col>

        <b-col cols="12">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              md="4"
              lg="3"
              v-for="company in companies"
              :key="company.id"
              class="mb-3"
            >
              <b-card class="h-100">
                <b-row>
                  <b-col cols="3" class="text-center">
                    <i class="fa fa-building fa-4x text-muted"></i>
                  </b-col>

                  <b-col cols="9">
                    <h5 class="h3 title">
                      <span class="d-block mb-1" v-html="company.name"></span>
                      <small
                        class="h4 font-weight-light text-muted text-uppercase"
                        >Reg: {{ company.number }}</small
                      >
                    </h5>
                    <router-link
                      :to="`/companies/${company.id}`"
                      class="mt-3 stretched-link"
                    >
                      View Details
                      <i class="fa fa-arrow-right ml-2"></i>
                    </router-link>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
            <b-col sm="6" md="4" lg="3" class="mb-3">
              <b-card v-if="!loading && companies.length > 0" class="h-100">
                <b-card-body class="h-100 d-table w-100 text-center">
                  <router-link
                    to="/companies/create"
                    size="sm"
                    variant="neutral"
                    class="h-100 stretched-link d-table-cell align-middle"
                  >
                    New Company
                    <i class="fa fa-plus ml-2"></i>
                  </router-link>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";

export default {
  name: "starter-page",
  components: {
    StatsCard,
    RouteBreadCrumb,
    Loading
  },
  data() {
    return {
      companies: [],
      loading: false
    };
  },
  computed: {
    account: function() {
      return this.$store.state.account;
    }
  },
  created() {
    this.loading = true;
    this.axios
      .get(`/v1/accounts/${this.account.id}/companies`)
      .then(response => {
        this.loading = false;
        this.companies = response.data; // TODO: restore
      })
      .catch(err => {
        this.loading = false;
        console.error("Error: ", err);
      });
  }
};
</script>
<style>
.starter-page {
  min-height: calc(100vh - 380px);
}
</style>
